import { supabase } from "../supabase-client.js";

const SESSION_ID_KEY = "rdm_session_id";
const DEDUPE_PREFIX = "rdm_track_dedupe";

const isBrowser = () =>
   typeof window !== "undefined" &&
   typeof localStorage !== "undefined" &&
   typeof sessionStorage !== "undefined";

const createRandomId = () => {
   if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
   }

   return `sess-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getOrCreateSessionId = () => {
   if (!isBrowser()) return "server-session";

   const existing = localStorage.getItem(SESSION_ID_KEY);
   if (existing) return existing;

   const sessionId = createRandomId();
   localStorage.setItem(SESSION_ID_KEY, sessionId);
   return sessionId;
};

const shouldTrack = (eventKey, ttlMs = 4000) => {
   if (!isBrowser()) return true;

   const fullKey = `${DEDUPE_PREFIX}:${eventKey}`;
   const now = Date.now();
   const lastValue = Number(sessionStorage.getItem(fullKey) || 0);

   if (lastValue && now - lastValue < ttlMs) {
      return false;
   }

   sessionStorage.setItem(fullKey, String(now));
   return true;
};

const browserMeta = () => {
   if (!isBrowser()) {
      return { referrer: null, userAgent: null };
   }

   return {
      referrer: document.referrer || null,
      userAgent: navigator.userAgent || null,
   };
};

export const registerVisit = async ({ pathname }) => {
   try {
      const page = pathname || "/";
      if (!shouldTrack(`visit:${page}`)) return;

      const sessionId = getOrCreateSessionId();
      const { referrer, userAgent } = browserMeta();

      const { error } = await supabase.from("visitas").insert({
         pagina: page,
         session_id: sessionId,
         referrer,
         user_agent: userAgent,
      });

      if (error) {
         console.error("Error registrando visita:", error.message || error);
      }
   } catch (error) {
      console.error("Error en registerVisit:", error);
   }
};

export const registerObraConsulta = async ({ obraId, obraTitulo, pagina = "/obrasdet" }) => {
   try {
      const normalizedId = Number(obraId);
      if (!Number.isFinite(normalizedId)) return;

      if (!shouldTrack(`obra:${normalizedId}:${pagina}`)) return;

      const sessionId = getOrCreateSessionId();
      const { referrer, userAgent } = browserMeta();

      const { error } = await supabase.from("obra_consultas").insert({
         obra_id: normalizedId,
         obra_titulo: obraTitulo || null,
         pagina,
         session_id: sessionId,
         referrer,
         user_agent: userAgent,
      });

      if (error) {
         console.error("Error registrando consulta de obra:", error.message || error);
      }
   } catch (error) {
      console.error("Error en registerObraConsulta:", error);
   }
};
